<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue';
const subtitles = [
  'login.login.Empower every conversation',
  'login.login.Conversations reimagined',
  'login.login.Unleash the power of conversation',
  'login.login.Create, Communicate, Empower',
  'login.login.Define the future of conversation',
  'login.login.Beyond words their vision',
  'login.login.Everything possible has an urge to exist',
];

const currentIndex = ref(0);
const currentSubtitle = computed(() => subtitles[currentIndex.value]);

const pickRandomSubtitle = () => {
  currentIndex.value = Math.floor((Math.random() * subtitles.length));
};

const pickNextSubtitle = () => {
  const length = subtitles.length;
  if (currentIndex.value === length - 1) {
    currentIndex.value = 0;
  } else {
    currentIndex.value ++;
  }
};

let interval: ReturnType<typeof setInterval>;

pickRandomSubtitle();

onMounted(() => {
  interval = setInterval(pickNextSubtitle, 5000);
});

onUnmounted(() => {
  clearInterval(interval);
});
</script>

<template>
  <div class="relative">
    <Transition
      name="fade"
      mode="out-in"
    >
      <div
        :key="currentIndex"
      >
        {{ $t(currentSubtitle) }}
      </div>
    </Transition>
  </div>
</template>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
}
</style>
